import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const CreateCourse = () => {
  const navigate=useNavigate()
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subcategories, setSubcategories] = useState([]);
  const [courseName, setCourseName] = useState("");
  const [courseImage, setCourseImage] = useState(null);
  const [courseImagePreview, setCourseImagePreview] = useState(null);
  const [courseDescription, setCourseDescription] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [courseType, setCourseType] = useState('free'); // default selected
  const [price, setPrice] = useState('');

  useEffect(() => {
    fetch(`${BASE_URL}/categories/list/`,{  headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        }})
      .then((res) => res.json())
      .then((data) => setCategories(data))
      .catch((err) => console.error(err));
  }, []);

  const handleCategoryChange = (e) => {
    const categoryId = parseInt(e.target.value);
    setSelectedCategory(categoryId);
    const category = categories.find((cat) => cat.id === categoryId);
    setSubcategories(category ? category.subcategories : []);
    setSelectedSubcategory(null);
  };

  const handleImageChange = (file) => {
    setCourseImage(file);
    setCourseImagePreview(URL.createObjectURL(file));
  };

  const handleClearImage = () => {
    setCourseImage(null);
    setCourseImagePreview(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith("image/")) {
      handleImageChange(file);
    }
  };
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);
  setSubmitStatus(null);
 
  try {
    const formData = new FormData();
    formData.append("name", courseName);
    formData.append("description", courseDescription);
    formData.append("category", selectedCategory ? parseInt(selectedCategory) : "");
    formData.append("subcategory", selectedSubcategory ? parseInt(selectedSubcategory) : "");
    formData.append("price",price)
    formData.append("course_type",courseType)
    
    if (courseImage) formData.append("image", courseImage);

    const response = await fetch(`${BASE_URL}/courses/create/`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        "x-api-key": process.env.REACT_APP_X_API_KEY
      },
    });

    const data = await response.json();

    if (response.ok) {
      setSubmitStatus("success");
    //   console.log("Course created:", data);
      navigate('/teacher/course')
      // Reset form
      setCourseName("");
      setCourseDescription("");
      setSelectedCategory(null);
      setSelectedSubcategory(null);
      setCourseImage(null);
      setCourseImagePreview(null);
      setSubcategories([]);
    } else {
      throw new Error(data.message || "Failed to create course");
    }
  } catch (err) {
    console.error(err);
    setSubmitStatus("error");
  } finally {
    setIsLoading(false);
  }
};


  const isFormValid = courseName && courseDescription && selectedCategory && selectedSubcategory;

  return (
  <div className="max-w-5xl mx-auto mt-5 p-8 bg-white rounded-2xl shadow-sm border border-gray-100">

  {/* Header */}
  <div className="flex items-center gap-3 mb-8">
    <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
      </svg>
    </div>
    <div>
      <h2 className="text-xl font-semibold text-gray-900">Create a New Course</h2>
      <p className="text-sm text-gray-500 mt-0.5">Fill in the details below</p>
    </div>
  </div>

  {submitStatus === "success" && (
    <div className="flex items-center gap-2 p-4 bg-green-50 border border-green-200 text-green-700 rounded-xl mb-6">
      <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span className="text-sm font-medium">Course created successfully!</span>
    </div>
  )}

  {submitStatus === "error" && (
    <div className="flex items-center gap-2 p-4 bg-red-50 border border-red-200 text-red-600 rounded-xl mb-6">
      <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span className="text-sm font-medium">Failed to create course. Please try again.</span>
    </div>
  )}

  <form
    onSubmit={handleSubmit}
    className={isLoading ? "opacity-70 pointer-events-none" : ""}
  >
    {/* Course Name */}
    <div className="mb-5">
      <div className="flex items-center gap-2 mb-2">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          Course Name <span className="text-red-500">*</span>
        </label>
      </div>
      <input
        type="text"
        value={courseName}
        onChange={(e) => setCourseName(e.target.value)}
        placeholder="e.g. Introduction to Machine Learning"
        required
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
    </div>

    {/* Course Image */}
    <div className="mb-5">
      <div className="flex items-center gap-2 mb-2">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          Course Image
        </label>
      </div>

      <div
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onClick={() => document.getElementById("fileInput")?.click()}
        className={`border-2 border-dashed rounded-xl h-[120px] flex items-center justify-center cursor-pointer transition relative overflow-hidden
          ${
            isDragging
              ? "border-[#0f6abf] bg-[#e8f0f7] scale-[1.02]"
              : courseImagePreview 
                ? "border-gray-300 bg-gray-50" 
                : "border-gray-300 bg-gray-50 hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10"
          }`}
      >
        {courseImagePreview ? (
          <div className="relative w-full h-full flex items-center justify-center">
            <img
              src={courseImagePreview}
              alt="Course preview"
              className="max-h-full max-w-full object-cover rounded-lg"
            />
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                handleClearImage();
              }}
              className="absolute top-2 right-2 w-8 h-8 bg-black/70 hover:bg-black/90 text-white rounded-full flex items-center justify-center transition hover:scale-110"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        ) : (
          <div className="text-center px-5">
            <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mx-auto mb-2">
              <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <p className="text-sm text-gray-500 font-medium">
              Drag & drop image here or click to upload
            </p>
          </div>
        )}

        <input
          type="file"
          id="fileInput"
          accept="image/*"
          hidden
          onChange={(e) =>
            e.target.files &&
            e.target.files[0] &&
            handleImageChange(e.target.files[0])
          }
        />
      </div>
    </div>

    {/* Description */}
    <div className="mb-5">
      <div className="flex items-center gap-2 mb-2">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          Course Description <span className="text-red-500">*</span>
        </label>
      </div>
      <textarea
        value={courseDescription}
        onChange={(e) => setCourseDescription(e.target.value)}
        placeholder="Enter course details, objectives, and requirements..."
        required
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all min-h-[120px] resize-y"
      />
    </div>

    {/* Main Category */}
    <div className="mb-5">
      <div className="flex items-center gap-2 mb-2">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          Main Category <span className="text-red-500">*</span>
        </label>
      </div>
      <select
        required
        onChange={handleCategoryChange}
        value={selectedCategory || ""}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none disabled:bg-gray-100 disabled:text-gray-500"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 16px center'
        }}
      >
        <option value="">Select Category</option>
        {categories.map((cat) => (
          <option key={cat.id} value={cat.id}>
            {cat.name}
          </option>
        ))}
      </select>
    </div>

    {/* Subcategory */}
    <div className="mb-5">
      <div className="flex items-center gap-2 mb-2">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          Subcategory <span className="text-red-500">*</span>
        </label>
      </div>
      <select
        required
        disabled={!selectedCategory}
        onChange={(e) => setSelectedSubcategory(e.target.value)}
        value={selectedSubcategory || ""}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none disabled:bg-gray-100 disabled:text-gray-500"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 16px center'
        }}
      >
        <option value="">Select Subcategory</option>
        {subcategories.map((sub) => (
          <option key={sub.id} value={sub.id}>
            {sub.name}
          </option>
        ))}
      </select>
    </div>

    {/* Course Type */}
    <div className="mb-5">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
        <label className="text-sm font-semibold text-gray-700">
          Course Type <span className="text-red-500">*</span>
        </label>
      </div>
      <div className="flex gap-4">
        <label className="flex-1">
          <input
            type="radio"
            name="courseType"
            value="free"
            checked={courseType === "free"}
            onChange={() => setCourseType("free")}
            className="sr-only"
          />
          <div className={`flex items-center justify-center gap-2 p-3 border-2 rounded-xl cursor-pointer transition-all ${
            courseType === "free"
              ? "border-[#0f6abf] bg-[#e8f0f7] text-[#0f6abf]"
              : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
          }`}>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm font-medium">Free</span>
          </div>
        </label>
        <label className="flex-1">
          <input
            type="radio"
            name="courseType"
            value="paid"
            checked={courseType === "paid"}
            onChange={() => setCourseType("paid")}
            className="sr-only"
          />
          <div className={`flex items-center justify-center gap-2 p-3 border-2 rounded-xl cursor-pointer transition-all ${
            courseType === "paid"
              ? "border-[#0f6abf] bg-[#e8f0f7] text-[#0f6abf]"
              : "border-gray-200 bg-white text-gray-700 hover:border-gray-300"
          }`}>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm font-medium">Paid</span>
          </div>
        </label>
      </div>
    </div>

    {/* Price */}
    {courseType === "paid" && (
      <div className="mb-5">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
          <label className="text-sm font-semibold text-gray-700">
            Price <span className="text-red-500">*</span>
          </label>
        </div>
        <div className="relative">
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">$</div>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="0.00"
            required
            className="w-full pl-8 pr-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          />
        </div>
      </div>
    )}

    {/* Submit Button */}
    <button
      type="submit"
      disabled={!isFormValid || isLoading}
      className="w-full py-3 mt-4 rounded-xl bg-[#0f6abf] text-white font-semibold text-sm hover:bg-[#0a5ca8] transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-2"
    >
      {isLoading ? (
        <>
          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          Creating Course...
        </>
      ) : (
        <>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
          </svg>
          Create Course
        </>
      )}
    </button>
  </form>
</div>

  );
};

export default CreateCourse;